import { IconButton } from "@material-ui/core";
import { useSelector } from "react-redux";
import React, { useState } from "react";
import { Col, Row, Button, Form, Image } from "react-bootstrap";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import EventsRatingReview from "./InsidePageComponent/EventsRatingReview";
import ItemsRatingReview from "./InsidePageComponent/ItemsRatingReview";
import OrdersRatingReview from "./InsidePageComponent/OrdersRatingReview";
import PayRatingReview from "./InsidePageComponent/PayRatingReview";
import RestaurantsRatingReview from "./InsidePageComponent/RestaurantsRatingReview";
import SeatingRatingReview from "./InsidePageComponent/SeatingRatingReview";

import { TextField, FormControl, Select, InputLabel } from "@material-ui/core";

import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { RightSideCountTop } from "../superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";

import isEmpty from "../../../../store/validation/is-Empty";
import { SortComponent } from "../../../reusableComponents/SortAndFilterComponent/SortComponent";
import SelectFilter from "../../../reusableComponents/selectFilter";
import CSVDownloader from "../../../reusableComponents/csvDownload/csvDownload";
import moment from "moment";

const SuperAdminRatingReviews = () => {
  //state

  const [insidePageTab, setInsidePageTab] = useState(1);
  const [search, setSearch] = useState("");

  const [tempLocation, setTempLocation] = useState("");
  const [location, setLocation] = useState("");
  const [tempStartDate, setTempStartDate] = useState("");
  const [tempEndDate, setTempEndDate] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const totalCountReview = useSelector((state) => {
    return !isEmpty(state.commonSuperAdmin.allReviews.stats)
      ? state.commonSuperAdmin.allReviews.stats
      : "";
  });

  const onStartDateChange = (e) => {
    setTempStartDate(e.target.value);
  };
  const onEndDateChange = (e) => {
    setTempEndDate(e.target.value);
  };
  const [tempRating, setTempRating] = useState("");
  const [rating, setRaiting] = useState("");
  const ratingData = [
    { title: "5 Star", id: 5 },
    { title: "4 Star", id: 4 },
    { title: "3 Star", id: 3 },
    { title: "2 Star", id: 2 },
    { title: "1 Star", id: 1 },
  ];
  const onChangeRating = (id) => {
    setTempRating(id);
  };
  const [selectedTab, setSelectedTab] = useState(1);
  const pageChanger = (value) => (e) => {
    setInsidePageTab(value);
  };
  const handleTab = (e) => {
    setSelectedTab(e);
  };
  const onChangeSearch = (e) => {
    setSearch(e.target.value);
  };

  const onClickSearch = () => {
    setLocation(tempLocation);
    setRaiting(tempRating);
    setStartDate(tempStartDate);
    setEndDate(tempEndDate);
    setShowFilter(false);
  };
  const [showFilter, setShowFilter] = useState(false);
  const handleShowFilter = () => {
    if (showFilter) {
      setLocation("");
      setRaiting("");
      setStartDate("");
      setEndDate("");
      setTempLocation("");
      setTempRating("");
      setTempStartDate("");
      setTempEndDate("");
    }
    setShowFilter(!showFilter);
  };

  const [state, setState] = useState({
    anchorEl: null,
    restaurantReverse: "",
  });

  /*********************************
   * @DESC SORT FILTER ACTION
   *********************************/
  const handleClick = (event) => {
    setState({
      ...state,
      anchorEl: event.currentTarget,
    });
  };

  const handleClose = () => {
    setState({
      ...state,
      anchorEl: null,
    });
  };

  const handleSelect = (value) => () => {
    setState({
      ...state,
      restaurantReverse: value,
      anchorEl: false,
    });
  };

  /*********************************
   * @DESC SELECTED DATE FILTER ACTION
   *********************************/
  const [dateQuery, setDateQuery] = useState("");
  const onDateChangeHandler = (data, type) => {
    setDateQuery(data);
  };

  // useEffect(() => {
  //   if (!isEmpty(dateQuery)) {
  //     dispatch(
  //       get_all_admin_active_vendors(
  //         auth.accessToken,
  //         true,
  //         dateQuery.startDate,
  //         dateQuery.endDate
  //       )
  //     );
  //     setAction(false);
  //   }
  // }, [dateQuery]);
  const [data, setData] = useState([]);

  const setDataa = (e) => setData(e);

  //  download data
  const RestaurantdownloadData = {
    headers: [
      { label: "Restaurant \n Location", key: "name" },
      { label: "User Name", key: "username" },
      { label: "Ratings \n - Date & Time", key: "rating" },
      { label: "Review Comment", key: "review" },
    ],
    tabledata: data
      ? data?.map((ele) => {
          return {
            name: `${
              ele && ele.restaurant_id && ele.restaurant_id.restaurant_name
            } \n ${ele && ele.restaurant_id && ele.restaurant_id.city}`,
            username: `${ele && ele.user_id && ele.user_id.first_name}  ${
              ele && ele.user_id && ele.user_id.last_name
            }`,
            rating: `${ele?.rating}  \n ${moment(ele.createdAt).format(
              "Do MMM YYYY"
            )} \n ${moment(ele.createdAt).format("hh:mm A")}`,
            review: ele?.review,
          };
        })
      : [],
  };

  // //seating download data
  const SeatingdownloadData = {
    headers: [
      { label: "Restaurant \n Location", key: "name" },
      { label: "User Name", key: "username" },
      { label: "Ratings \n - Date & Time", key: "rating" },
      { label: "Review Comment", key: "review" },
      { label: "Request Type \n Order ID", key: "requesttype" },
    ],
    tabledata: data
      ? data?.map((ele) => {
          return {
            name: `${
              ele && ele.restaurant_id && ele.restaurant_id.restaurant_name
            } \n ${ele && ele.restaurant_id && ele.restaurant_id.city}`,
            username: `${ele && ele.user_id && ele.user_id.first_name}  ${
              ele && ele.user_id && ele.user_id.last_name
            }`,
            rating: `${ele?.rating}  \n ${moment(ele.createdAt).format(
              "Do MMM YYYY"
            )} \n ${moment(ele.createdAt).format("hh:mm A")}`,
            review: ele?.review,
            requesttype: `${ele.diner_id && ele.diner_id.service_type} \n ${
              ele.diner_id && ele.diner_id._id
            } `,
          };
        })
      : [],
  };

  //evntsdownload data
  const EventsdownloadData = {
    headers: [
      { label: "Restaurant \n Location", key: "name" },
      { label: "User Name", key: "username" },
      { label: "Event Name", key: "eventname" },
      { label: "Ratings \n - Date & Time", key: "rating" },
      { label: "Review Comment", key: "review" },
      { label: "Request Type \n Order ID", key: "requesttype" },
    ],
    tabledata: data
      ? data?.map((ele) => {
          return {
            name: `${ele?.restaurant_id?.restaurant_name} \n ${ele?.restaurant_id?.city}`,
            username: `${ele?.user_id?.first_name} \n ${ele?.user_id?.last_name}`,
            eventname: ele?.event_id?.name,
            rating: `${ele?.rating}  \n ${moment(ele?.createdAt).format(
              "Do MMM YYYY"
            )} \n ${moment(ele?.createdAt).format("hh:mm A")}`,
            review: ele?.review,
            requesttype: `${ele?.event_request_id?.event_type} \n ${ele?.event_request_id?.event_request_id} `,
          };
        })
      : [],
  };
  //Itemsdownload data
  const ItemsdownloadData = {
    headers: [
      { label: "Restaurant \n Location", key: "name" },
      { label: "User Name", key: "username" },
      { label: "Item Name", key: "itemname" },
      { label: "Ratings \n - Date & Time", key: "rating" },
      { label: "Review Comment", key: "review" },
      { label: "Request Type \n Order ID", key: "requesttype" },
    ],
    tabledata: data
      ? data?.map((ele) => {
          return {
            name: `${ele?.restaurant_id?.restaurant_name} \n ${ele?.restaurant_id?.city}`,
            username: `${ele?.user_id?.first_name}  ${ele?.user_id?.last_name}`,
            itemname: ele?.item_id?.name,
            rating: `${ele?.rating}  \n ${moment(ele?.createdAt).format(
              "Do MMM YYYY"
            )} \n ${moment(ele?.createdAt).format("hh:mm A")}`,
            review: ele?.review,
            requesttype: "Reservation \n 1823232322",
          };
        })
      : [],
  };

  //ordersdownload data
  const OrdersdownloadData = {
    headers: [
      { label: "Restaurant \n Location", key: "name" },
      { label: "User Name", key: "username" },
      { label: "Ratings \n - Date & Time", key: "rating" },
      { label: "Review Comment", key: "review" },
      { label: "Request Type \n Order ID", key: "requesttype" },
    ],
    tabledata: data
      ? data?.map((ele) => {
          return {
            name: `${ele?.restaurant_id?.restaurant_name} \n ${ele?.restaurant_id?.city}`,
            username: `${ele?.user_id?.first_name}  ${ele?.user_id?.last_name}`,
            rating: `${ele?.rating}  \n ${moment(ele?.createdAt).format(
              "Do MMM YYYY"
            )} \n ${moment(ele?.createdAt).format("hh:mm A")}`,
            review: ele?.review,
            requesttype: `${ele?.order_id?.order_type} \n ${ele?.order_id?.order_id} `,
          };
        })
      : [],
  };
  //pay download data
  const paydownloadData = {
    headers: [
      { label: "Restaurant \n Location", key: "name" },
      { label: "User Name", key: "username" },
      { label: "Ratings \n - Date & Time", key: "rating" },
      { label: "Review Comment", key: "review" },
      { label: "Request Type \n Order ID", key: "requesttype" },
    ],
    tabledata: data
      ? data?.map((ele) => {
          return {
            name: `${ele?.restaurant_id?.restaurant_name} \n ${ele?.restaurant_id?.city}`,
            username: `${ele?.user_id?.first_name}  ${ele?.user_id?.last_name}`,
            rating: `${ele?.rating}  \n ${moment(ele?.createdAt).format(
              "Do MMM YYYY"
            )} \n ${moment(ele?.createdAt).format("hh:mm A")}`,
            review: ele?.review,
            requesttype: `${ele?.transactional_id?.transaction_type} \n ${ele?.transactional_id?._id} `,
          };
        })
      : [],
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <div className="super-admin-inside-right-side-panel">
              <Row>
                <Col md={12} className="pt-4 pb-3">
                  <div className="f24_700_HelveticaNeue">All Reviews</div>
                </Col>
                <Col md={12}>
                  <div className="d-flex justify-content-end mt-3 mb-3">
                    <RightSideCountTop
                      content={[
                        {
                          name: "Total Reviews",
                          value: `${
                            totalCountReview && totalCountReview[0].total
                          }`,
                          backgroundColor: "#FFEDE9",
                          color: "#EE3A23",
                        },
                        {
                          name: "Hidden Reviews",
                          value: `${
                            totalCountReview && totalCountReview[0].hiddenTotal
                          }`,
                          backgroundColor: "#EFEBFB",
                          color: "#6F32C9",
                        },
                        {
                          name: `Reviews for ${
                            selectedTab && selectedTab === 1
                              ? "Restaurant"
                              : selectedTab === 2
                              ? "Seating"
                              : selectedTab === 3
                              ? "Events"
                              : selectedTab === 4
                              ? "Items"
                              : selectedTab === 5
                              ? "Orders"
                              : selectedTab === 6
                              ? "Pay"
                              : ""
                          }`,
                          value: `${
                            selectedTab && selectedTab === 1
                              ? data && data.length
                              : totalCountReview &&
                                totalCountReview[0].typeTotal
                          }`,
                          backgroundColor: "#D8F3F4",
                          color: "#008B90",
                        },
                      ]}
                    />
                    {console.log("selectedTab ===>", selectedTab)}
                  </div>
                </Col>
                <Col md={12}>
                  <Row>
                    <Col md={5}>
                      <Form.Control
                        type="text"
                        placeholder="Search by restaurant name"
                        className="amSearch"
                        value={search}
                        onChange={(e) => onChangeSearch(e)}
                      />
                    </Col>
                    <Col md={2}></Col>
                    <Col md={5}>
                      <div className="d-flex justify-content-end align-items-center">
                        <div className="col-6">
                          <SelectFilter onDateChange={onDateChangeHandler} />
                        </div>
                        <div className="col-4 d-flex align-items-center justify-content-between">
                          <SortComponent
                            handleClick={handleClick}
                            anchorEl={state.anchorEl}
                            handleClose={handleClose}
                            selectClick={(data) => handleSelect(data)}
                          />
                          <div
                            className="f10-400"
                            align="center"
                            onClick={handleShowFilter}
                          >
                            <img
                              src={require("../../../../assets/images/iconButton/filtericon.png")}
                              width="35px"
                            />
                            <br />
                            Filter
                          </div>
                          <div className="f10-400" align="center">
                            <CSVDownloader
                              filename={"Reviews-Ratings-Report"}
                              headers={
                                selectedTab === 1
                                  ? RestaurantdownloadData.headers
                                  : selectedTab === 2
                                  ? SeatingdownloadData.headers
                                  : selectedTab === 3
                                  ? EventsdownloadData.headers
                                  : selectedTab === 4
                                  ? ItemsdownloadData.headers
                                  : selectedTab === 5
                                  ? OrdersdownloadData.headers
                                  : paydownloadData.headers
                              }
                              data={
                                selectedTab === 1
                                  ? RestaurantdownloadData.tabledata
                                  : selectedTab === 2
                                  ? SeatingdownloadData.tabledata
                                  : selectedTab === 3
                                  ? EventsdownloadData.tabledata
                                  : selectedTab === 4
                                  ? ItemsdownloadData.tabledata
                                  : selectedTab === 5
                                  ? OrdersdownloadData.tabledata
                                  : paydownloadData.tabledata
                              }
                            />
                          </div>
                        </div>
                        {/* <div className="text-blue f15-500 ml-5 mr-3">
                          Filters
                        </div>
                        <IconButton
                          className="enDownIcon"
                          onClick={handleShowFilter}
                        >
                          <Image
                            src={require("../../../../assets/images/UserManagement/chevron-down.svg")}
                            alt="View"
                            title="View"
                          />
                        </IconButton> */}
                      </div>
                    </Col>
                  </Row>
                </Col>
                {showFilter && (
                  <Col md={12}>
                    <Row className="p-4" style={{ background: "#ffffff" }}>
                      {/* <Col md={5}>
                        Date Range
                        <div
                          className="d-flex justify-content-start"
                          style={{ alignItems: "center" }}
                        >
                          <TextField
                            type="date"
                            variant="outlined"
                            onChange={onStartDateChange}
                            value={tempStartDate}
                          />
                          &nbsp;To&nbsp;
                          <TextField
                            type="date"
                            variant="outlined"
                            onChange={onEndDateChange}
                            value={tempEndDate}
                          />
                        </div>
                        <br />
                      </Col> */}
                      <Col md={5}>
                        <Form.Group>
                          <TextField
                            variant="outlined"
                            label="Location"
                            className="w-100"
                            value={tempLocation}
                            onChange={(e) => setTempLocation(e.target.value)}
                            // value={props.searchByUserId}
                            // onChange={(e) =>
                            //   onChangeLocation(e.target.value)
                            // }
                          />
                        </Form.Group>
                      </Col>
                      <Col md={5}>
                        <Form.Group>
                          <FormControl variant="outlined" className="w-100">
                            <InputLabel htmlFor="outlined-Status">
                              Rating
                            </InputLabel>
                            <Select
                              // value={props.Status}
                              // onChange={props.handleChangeCode}
                              onChange={(e) => onChangeRating(e.target.value)}
                              label="Rating"
                              inputProps={{
                                name: "Rating",
                                id: "outlined-Rating",
                              }}
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              {ratingData.map((data) => {
                                return (
                                  <option value={data.id} key={data.id}>
                                    {data.title}
                                  </option>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <div className="d-flex align-items-center">
                          <Button
                            variant="outline-secondary"
                            className="btn-lg mr-4 px-5"
                            onClick={handleShowFilter}
                            //onClick={props.handleShowFilter}
                          >
                            Cancel
                          </Button>
                          <Button
                            variant="danger"
                            className="btn-lg px-5"
                            onClick={() => onClickSearch()}
                            //onClick={props.handleSaveButton}
                          >
                            Search
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                )}
                <Col md={7}>
                  <div className="d-flex align-items-center">
                    <Button
                      variant="link"
                      className={`px-0 mr-4 text-grayLink f12-500 ${
                        insidePageTab === 1 ? "active" : ""
                      }`}
                      onClick={pageChanger(1)}
                    >
                      New
                    </Button>
                    <Button
                      variant="link"
                      className={`px-0 mr-4 text-grayLink f12-500 ${
                        insidePageTab === 2 ? "active" : ""
                      }`}
                      onClick={pageChanger(2)}
                    >
                      Hidden
                    </Button>
                    <Button
                      variant="link"
                      className={`px-0 mr-4 text-grayLink f12-500 ${
                        insidePageTab === 3 ? "active" : ""
                      }`}
                      onClick={pageChanger(3)}
                    >
                      All
                    </Button>
                  </div>
                </Col>
              </Row>

              <hr />
              <div className="enTabs d-flex flex-wrap align-items-center mt-4 mb-2">
                <Button
                  onClick={(e) => handleTab(1)}
                  className={`mb-2 ${selectedTab === 1 ? "active" : ""}`}
                >
                  Restaurants
                </Button>
                <Button
                  onClick={(e) => handleTab(2)}
                  className={`mb-2 ${selectedTab === 2 ? "active" : ""}`}
                >
                  Seating
                </Button>
                <Button
                  onClick={(e) => handleTab(3)}
                  className={`mb-2 ${selectedTab === 3 ? "active" : ""}`}
                >
                  Events
                </Button>
                <Button
                  onClick={(e) => handleTab(4)}
                  className={`mb-2 ${selectedTab === 4 ? "active" : ""}`}
                >
                  Items
                </Button>
                <Button
                  onClick={(e) => handleTab(5)}
                  className={`mb-2 ${selectedTab === 5 ? "active" : ""}`}
                >
                  Orders
                </Button>
                <Button
                  onClick={(e) => handleTab(6)}
                  className={`mb-2 ${selectedTab === 6 ? "active" : ""}`}
                >
                  Pay
                </Button>
              </div>
              <hr />
              {selectedTab === 1 && (
                <RestaurantsRatingReview
                  setDataa={setDataa}
                  data={data}
                  insidePageTab={insidePageTab}
                  search={search}
                  location={location}
                  rating={rating}
                  startDate={startDate}
                  endDate={endDate}
                  sortFilter={state.restaurantReverse}
                  dateQueryProps={dateQuery}
                />
              )}
              {selectedTab === 2 && (
                <SeatingRatingReview
                  setDataa={setDataa}
                  data={data}
                  insidePageTab={insidePageTab}
                  search={search}
                  location={location}
                  rating={rating}
                  startDate={startDate}
                  endDate={endDate}
                  sortFilter={state.restaurantReverse}
                  dateQueryProps={dateQuery}
                />
              )}
              {selectedTab === 3 && (
                <EventsRatingReview
                  setDataa={setDataa}
                  data={data}
                  insidePageTab={insidePageTab}
                  search={search}
                  location={location}
                  rating={rating}
                  startDate={startDate}
                  endDate={endDate}
                  sortFilter={state.restaurantReverse}
                  dateQueryProps={dateQuery}
                />
              )}
              {selectedTab === 4 && (
                <ItemsRatingReview
                  setDataa={setDataa}
                  data={data}
                  insidePageTab={insidePageTab}
                  search={search}
                  location={location}
                  rating={rating}
                  startDate={startDate}
                  endDate={endDate}
                  sortFilter={state.restaurantReverse}
                  dateQueryProps={dateQuery}
                />
              )}
              {selectedTab === 5 && (
                <OrdersRatingReview
                  setDataa={setDataa}
                  data={data}
                  insidePageTab={insidePageTab}
                  search={search}
                  location={location}
                  rating={rating}
                  startDate={startDate}
                  endDate={endDate}
                  sortFilter={state.restaurantReverse}
                  dateQueryProps={dateQuery}
                />
              )}
              {selectedTab === 6 && (
                <PayRatingReview
                  setDataa={setDataa}
                  data={data}
                  insidePageTab={insidePageTab}
                  search={search}
                  location={location}
                  rating={rating}
                  startDate={startDate}
                  endDate={endDate}
                  sortFilter={state.restaurantReverse}
                  dateQueryProps={dateQuery}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SuperAdminRatingReviews;
